import React from "react";

import { Route, Redirect } from "react-router-dom";
import { useAuth } from "views/Authentication/AuthContext";
import { URLS } from "./constants";
import PropTypes from "prop-types";

export const ProtectedRoute = ({
  component: Component,
  permissions,
  ...rest
}) => {
  const { loggedIn } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        let newProps = { ...props, ...{ permissions: permissions } };

        if (loggedIn) {
          return <Component {...newProps} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: URLS.LOGIN,
              }}
            />
          );
        }
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType,
  permissions: PropTypes.object,
};

export default ProtectedRoute;
